import React from 'react';
import { PreviewHeader, PreviewMealDeals } from '../../preview';
import { AcvtPlaceholderContent } from '../placeholder-content';
import style from './style.module.scss';

type AcvtHomeProps = {
    featuredCarousel?: React.ReactNode;
    promos?: React.ReactNode;
    games?: React.ReactNode;
    onEditMode?: boolean;
    hideHeader?: boolean; // Hide PreviewHeader when MainBanner is used in featuredCarousel
    hideMealDeals?: boolean; // Hide PreviewMealDeals when MainBanner is used in featuredCarousel
};

export const AcvtHomePage = ({
    featuredCarousel,
    promos,
    games,
    onEditMode = false,
    hideHeader = false,
    hideMealDeals = false,
}: AcvtHomeProps) => {
    return (
        <div className={style.home_content}>
            {!hideHeader && <PreviewHeader />}
            <div className={style.scroll_content}>
                <div className={style.curved_header} />
                {featuredCarousel}
                {!hideMealDeals && <PreviewMealDeals />}
                {promos}
                {games}
                {onEditMode && <AcvtPlaceholderContent />}
            </div>
        </div>
    );
};
